export default "__VITE_ASSET__DVkunazi__"